import Vue from "vue";
import Vuesax from "vuesax";
import axios from "axios";
import App from "./App.vue";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";
import store from "./store/store";
import router from "./router";
import "@/assets/scss/style.scss";

//Vue.config.productionTip = true;
// dev
//Vue.config.devtools = true;
// prod
Vue.config.devtools = false;

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: "#532B29",
      success: "rgb(23, 201, 100)",
      warning: "rgb(255, 130, 0)",
      dark: "rgb(36, 33, 69)",
    },
  },
});

// dev
//localhost
//const axiosInstance = axios.create({
//  baseURL: "http://localhost:90/etelrendeles/api/controller",
//  withCredentials: true,
//});

//clouddemo
//const axiosInstance = axios.create({baseURL: 'https://clouddemo.cts.hu/etelrendeles/api/controller', withCredentials: true});

// prod
const axiosInstance = axios.create({
  baseURL: window.location.protocol + "//" + window.location.hostname + "/etelrendeles/api/controller",
  withCredentials: true,
});

Vue.prototype.$axios = axiosInstance;
export { axiosInstance };

new Vue({
  store: store,
  router,
  render: (h) => h(App),
  data() {
    return {
      imagePath: window.location.protocol + "//" + window.location.hostname + "/etelrendeles/api/images/",
    };
  },
  methods: {
    exterminatus(msg = "") {
      document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      store.commit("logoutUser");
      router.push("/dashboard");
      this.$vs.notify({
        title: "Rendszerüzenet",
        position: "top-right",
        text: msg,
        color: "danger",
        icon: "error",
      });
    },
  },
}).$mount("#app");
